import { useSyncExternalStore } from "react";

type SwitchState = {
	isSwitching: boolean;
	destination: string | null;
	sourcePathname: string | null;
};

let state: SwitchState = {
	isSwitching: false,
	destination: null,
	sourcePathname: null,
};
const listeners = new Set<() => void>();

function emit() {
	for (const listener of listeners) {
		listener();
	}
}

export function startDashboardSwitch(label: string, pathname: string) {
	state = { isSwitching: true, destination: label, sourcePathname: pathname };
	emit();
}

export function clearDashboardSwitch() {
	if (!state.isSwitching) return;
	state = { isSwitching: false, destination: null, sourcePathname: null };
	emit();
}

export function getDashboardDestination(): string | null {
	return state.destination;
}

const serverSnapshot: SwitchState = {
	isSwitching: false,
	destination: null,
	sourcePathname: null,
};

export function useDashboardSwitch(): SwitchState {
	return useSyncExternalStore(
		(cb) => {
			listeners.add(cb);
			return () => listeners.delete(cb);
		},
		() => state,
		() => serverSnapshot,
	);
}
